export default class TimezoneDetector {
  static detectTimezone() {
    if (!window.Intl || !Intl.DateTimeFormat) return null;

    try {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (typeof tz === 'string' && /^[A-Za-z_]+\/[A-Za-z0-9_\-]+$/.test(tz)) {
        return tz;
      }
    } catch (e) {
      console.warn('Timezone detection failed');
    }

    return null;
  }

  init(field) {
    if (!field) return;

    // overwrite only if empty OR explicitly UTC (optional)
    if (field.value && field.value !== 'UTC') return;

    const tz = TimezoneDetector.detectTimezone();
    if (tz) field.value = tz;
  }
}
